export default __webpack_public_path__ + "static/media/00.02810ad2.jpg";